import * as React from 'react';
const SvgExcelCsv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="#20855A"
      d="M14 22v-6.5h8v2.339c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031zM14 22v-6.5H6v2.339c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.357.031z"
    />
    <path fill="#22A070" d="M14 8.5h8v7h-8z" />
    <path fill="#20855A" d="M6 8.5h8v7H6z" />
    <path
      fill="#2BBB80"
      d="M14 2v6.5h8V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2z"
    />
    <path
      fill="#22A070"
      d="M14 2v6.5H6V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C9.18 2 9.635 2 10.162 2z"
    />
    <path
      fill="#226E4E"
      d="M4.6 7c-.329 0-.613 0-.847.02a1.9 1.9 0 0 0-.73.184c-.352.18-.639.467-.819.82a1.9 1.9 0 0 0-.185.73C2 8.986 2 9.27 2 9.6v4.798c0 .33 0 .614.02.848.02.247.064.493.184.73.18.352.467.639.82.819.236.12.482.165.73.185.233.019.517.019.847.019h4.798c.33 0 .614 0 .848-.02a1.9 1.9 0 0 0 .73-.184c.352-.18.639-.467.819-.82a1.9 1.9 0 0 0 .185-.73C12 15.014 12 14.73 12 14.4V9.601c0-.33 0-.614-.02-.848a1.9 1.9 0 0 0-.184-.73 1.88 1.88 0 0 0-.82-.819 1.9 1.9 0 0 0-.73-.185C10.014 7 9.73 7 9.4 7z"
    />
    <path
      fill="#fff"
      d="M3.959 14.065c-.958 0-1.55-.625-1.55-1.638v-.003c0-1.005.6-1.63 1.541-1.63.853 0 1.395.525 1.427 1.205v.02h-.794l-.006-.026c-.053-.299-.26-.527-.615-.527-.419 0-.683.36-.683.96v.004c0 .615.264.964.686.964.343 0 .556-.211.615-.528l.003-.026h.797v.017c-.041.686-.583 1.208-1.421 1.208m3.126 0c-.87 0-1.354-.402-1.42-.997l-.004-.026h.835l.006.026c.056.247.24.39.583.39.322 0 .519-.126.519-.328v-.003c0-.167-.106-.264-.414-.331l-.533-.111c-.61-.13-.917-.434-.917-.903v-.003c0-.597.516-.984 1.316-.984.835 0 1.3.442 1.321.993v.03h-.788l-.003-.024c-.03-.226-.214-.396-.53-.396-.296 0-.48.132-.48.334v.003c0 .162.108.267.424.334l.533.115c.656.137.926.395.926.858v.003c0 .615-.565 1.02-1.374 1.02M9.692 14l-1.087-3.14h.915l.656 2.384h.017l.648-2.385h.893L10.656 14z"
    />
  </svg>
);
export default SvgExcelCsv;
